import { createLoginPage } from './kernelLogin';
import NexoraLogo from '../components/NexoraLogo';

export default createLoginPage({
  brand: {
    mode: 'svg',
    mark: <NexoraLogo />,
  },
  demoHint: false,
  // 10 varianti di sfondo (vedi .login-bg-1..10 in App.css): una scelta a caso ad ogni accesso.
  bgVariants: 10,
  themeToggle: true,
});
